module.exports = __webpack_public_path__ + "img/calendar_icon_pink.2eed4ba3.svg";